<template>
  <div>
    <Loading v-if="loading"/>
    <Disposals v-if="isAdmin && !loading" v-bind:bookings="getAdminDisposals"> </Disposals>
  </div>
</template> 

<script>
import Disposals from "@/components/Disposals";
import Loading from "@/components/Loading"
export default {
  name: 'AdminWasteDisposals',
  components: { Disposals, Loading},
  data() {
    return {
    }
  },
  computed: {
    loading() {
      return this.$store.getters['admin/getLoading'];
    },
    isAdmin() {
      return this.$store.getters['auth/isAdmin'];
    },
    bookingError() {
      return this.$store.getters['admin/getBookingError'];
    },
    getAdminDisposals(){
      return this.$store.getters['admin/getAdminDisposals'];
    },
    query(){
      return this.$store.getters['admin/getAdminDisposalQuery'];
    }
  },
  watch: {
    bookingError(error) {
      if (error) {
        console.log(error);
      }
    }
  },
  mounted() {
    if(this.getAdminDisposals.length === 0){
      this.$store.dispatch('admin/fetchAdminDisposals', this.query);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>